import { Tooltip } from '@material-ui/core'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { PDFDownloadLink } from '@react-pdf/renderer'
import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { COLORES } from '../../../config/colores'
import Movimiento from '../../../models/movimiento/movimientoService'
import { MovimientoUtils } from '../../../models/movimiento/movimientoUtils'
import GenerarPdf from '../../Forms/SharedComponents/containers/GenerarPdf/GenerarPdf'
import * as actions from '../actions'
import Vista3dView from '../components/Vista3dView'

const COLUMNS_EXISTENCIAS = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'netoS1',
    label: 'Neto S1 [tn]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'netoS2',
    label: 'Neto S2 [tn]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'netoS3',
    label: 'Neto S3 [tn]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'netoS5',
    label: 'Neto S5 [tn]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Neto Total [tn]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'silosEnUso',
    label: 'Silos en Uso',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'silosLlenos',
    label: 'Silos Llenos',
    options: {
      filter: true,
      sort: true
    }
  }
]

const COLUMNS_EXISTENCIAS_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    mantenerCase: true
  },
  {
    name: 'netoS1',
    label: 'S1 [tn]',
    mantenerCase: true
  },
  {
    name: 'netoS2',
    label: 'S2 [tn]',
    mantenerCase: true
  },
  {
    name: 'netoS3',
    label: 'S3 [tn]',
    mantenerCase: true
  },
  {
    name: 'netoS5',
    label: 'S5 [tn]',
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotal',
    label: 'Neto Total [tn]',
    mantenerCase: true
  },
  {
    name: 'silosEnUso',
    label: 'Silos en Uso',
    mantenerCase: true
  },
  {
    name: 'silosLlenos',
    label: 'Silos Llenos',
    mantenerCase: true
  }
]

class Vista3d extends Component {
  constructor (props) {
    super(props)
    this.actualizarDatosEstadoElevador = this.actualizarDatosEstadoElevador.bind(this)
    this.actualizarDatosSilos3d = this.actualizarDatosSilos3d.bind(this)
    this.parseData = this.parseData.bind(this)
    this.getData = this.getData.bind(this)
  }

  actualizarDatosSilos3d (data) {
    this.props.updateGraFicoSilos(data)
  }

  actualizarDatosEstadoElevador (data) {
    this.props.updateTablaSilosEstadoElevador(data)
  }

  async getDataEstadoElevador () {
    return this.parseDataEstadoElevador(await Movimiento.getEstadoElevador())
  }

  async getData () {
    return this.parseData(await Movimiento.getMovimiento())
  }

  parseData (data) {
    return MovimientoUtils.parseData(data)
  }

  parseDataEstadoElevador (data) {
    return MovimientoUtils.parseDataEstadoElevador(data)
  }

  async componentDidMount () {
    const dataP = this.getData()
    const dataEstadoElevadorP = this.getDataEstadoElevador()
    const [data, dataEstadoElevador] = [await dataP, await dataEstadoElevadorP]
    const dataWithoutNulls = dataEstadoElevador.map((d) =>
      Object.keys(d).reduce(
        (obj, key) => ({
          ...obj,
          [key]:
          d[key] === null || d[key] === undefined
            ? ''
            : `${d[key]}`.trim()
        }),
        {}
      )
    )
    const customToolbar = () => (
      <div>
        <PDFDownloadLink
          document={
            <GenerarPdf
              data={[dataWithoutNulls]}
              fields={COLUMNS_EXISTENCIAS_TO_PRINT}
              info={{
                titulo: 'Existencias en Elevador',
                subtitulo: `Fecha: ${moment().format('DD/MM/YYYY')}`,
                version: `${this.props.versionLaridae}`
              }}
            />
          }
          fileName='Existencias en Elevador.pdf'
          style={{
            textDecoration: 'none',
            marginTop: '12px',
            color: COLORES.blue.light,
            fontSize: '16px',
            fontFamily: 'sans-serif',
            borderRadius: '5px 5px 5px 5px'
          }}
        >
          {({ blob, url, loading, error }) =>
            loading ? (
              '...'
            ) : (
              <Tooltip title={'Guardar en PDF'}>
                <PictureAsPdfIcon fontSize='default' />
              </Tooltip>
            )
          }
        </PDFDownloadLink>
      </div>
    )
    this.actualizarDatosEstadoElevador({
      columns: COLUMNS_EXISTENCIAS,
      data: dataEstadoElevador,
      title: 'Estado Elevador',
      isLoading: false,
      extraOptions: { customToolbar, print: false }
    })
    this.actualizarDatosSilos3d({
      data,
      isLoading: false
    })
  }

  render () {
    return <Vista3dView />
  }
}

const mapStateToProps = (state) => {
  return {
    versionLaridae: state.utils.versionLaridae
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(Vista3d)
